<template>
  <v-app class="primary">
    <v-main>
      <rsvp-form :event="event"></rsvp-form>
    </v-main>
  </v-app>
</template>

<script>
import RsvpForm from "./components/RsvpForm.vue";
export default {
  name: "App",
  props: {
    event: {},
  },
  components: { RsvpForm },
  data: () => ({}),
};
</script>

<style lang="scss">
@import url("https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css");
.theme--light.v-application {
  background: transparent !important;
}
.v-application--wrap {
  min-height: auto !important;
}
.v-main {
  fieldset {
    padding: 0px !important;
  }
  input {
    border-style: none;
  }
}
</style>